import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const BusinessAnnouncement = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/business-updates-revamp/components/BusinessAnnouncementContent'
      )
  ),
  Header: lazy(
    () =>
      import(
        'components/direct-sales/business-updates-revamp/components/BusinessAnnouncementHeader'
      )
  )
};

export default BusinessAnnouncement;
